/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Product_Source_Lot_PlaceholderInputs */

const vi_pll_new_product_source_lot_placeholder = /** @type {(inputs: Pll_New_Product_Source_Lot_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô thành phẩm nguồn...`)
};

/**

* @param {Pll_New_Product_Source_Lot_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_product_source_lot_placeholder = /** @type {((inputs?: Pll_New_Product_Source_Lot_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Product_Source_Lot_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_product_source_lot_placeholder(inputs)
});